<template>
  <div style="height:100%">

    <el-dialog class="dialog-main" :title="agreementDialogTitle" :visible.sync="agreementDialogVisible" width="80%"
               center>
      <div class="dialog-content" v-html="agreementDialog.content"></div>
      <span slot="footer" class="dialog-footer">
        <el-button style="width: calc(50% - 10px)" @click="agreementDialogVisible = false">取 消</el-button>
        <el-button style="width: calc(50% - 10px)" type="primary" @click="onDialogEnsure">确 定</el-button>
      </span>
    </el-dialog>

    <!-- theme-a：居中标题 + 右上圆形返回 + 卡片内被访人搜索（对齐 13-register-visitor 设计稿） -->
    <div class="common-page-box">
      <div class="back-btn" @click="$router.back()">
        <svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="#1a1d21" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>
      </div>

      <div class="page-title" style="font-size:64px;margin-top:48px">{{ title }}</div>

      <div class="card" style="margin:64px 96px 96px;flex:1;padding:72px 120px;display:flex;flex-direction:column;overflow:auto">
        <div class="field-row">
          <span class="field-label">{{ subTitle }}</span>
          <el-input v-model="employee" :placeholder="searchPlaceholder" style="flex:1"
                    @keyup.enter.native="onSearch"></el-input>
          <button class="ta-btn primary" style="height:112px;padding:0 72px;flex:none" @click="onSearch">搜 索</button>
        </div>

        <div v-if="hasAnyAgreement" class="agree" style="margin-top:40px" @click="haveRead = !haveRead">
          <span class="box" :class="{checked: haveRead}">
            <svg v-if="haveRead" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5l5.5 5.5L20 6.5"/></svg>
          </span>
          <span>请阅读并同意</span>
          <a v-if="agreement.valid" @click.stop="showAgreement">《访客须知》</a>
          <span v-if="agreement.valid && userAgreement.valid">、</span>
          <a v-if="userAgreement.valid" @click.stop="showUserAgreement">《用户协议》</a>
          <span v-if="(agreement.valid || userAgreement.valid) && privacyAgreement.valid">、</span>
          <a v-if="privacyAgreement.valid" @click.stop="showPravicyAgreement">《隐私协议》</a>
        </div>

        <el-table v-if="searchResult.length > 0" :data="searchResult" class="local-table" border stripe
                  style="width:100%;margin-top:36px">
          <el-table-column prop="name" label="被访人姓名"></el-table-column>
          <el-table-column prop="departmentName" label="所在部门"></el-table-column>
          <el-table-column label="操作" width="200">
            <template v-slot="{row}">
              <el-button type="success" @click="onEnsureClick(row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div v-if="agreement.valid" class="notice" style="margin-top:auto;border-top:1px solid var(--line);padding-top:36px">
          <h3 style="font-size:32px">访客须知</h3>
          <div style="font-size:28px;line-height:1.75" v-html="agreement.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {searchEmployee} from '../../api/organize-api'
import {getEmployeeConfigSetting} from '../../api/setting-api'

export default {
  name: "LocalRegister",

  computed: {
    agreement() {
      return this.$store.state.visitorAgreement
    },
    privacyAgreement() {
      return this.$store.state.privacyAgreement
    },
    userAgreement() {
      return this.$store.state.userAgreement
    },
    // 三类协议均未配置时隐藏「请阅读并同意」勾选块（无内容可同意，裸文案徒增困惑）
    hasAnyAgreement() {
      return !!(this.agreement.valid || this.userAgreement.valid || this.privacyAgreement.valid)
    },
    // 被访员工查找方式：EMAIL=仅邮箱（邮箱为唯一验证字段），ALL=默认姓名/手机号
    emailOnly() {
      return this.employeeSetting.searchEmployeeBy === "EMAIL"
    },
    searchPlaceholder() {
      return this.emailOnly ? "请输入被访员工邮箱" : "请输入被访员工姓名/手机号"
    },
  },

  data() {
    return {
      title: "被访人选择",
      subTitle: "被访人",
      agreementDialogVisible: false,
      haveRead: false,

      employee: "",
      searchResult: [],

      // 员工信息设置（后台 系统设置>员工信息），默认与后台一致
      employeeSetting: {
        searchEmployeeBy: "ALL", // ALL | EMAIL
        nameSearch: "searchTypeFull", // searchTypeFull 完整查询 | searchTypePart 模糊查询
      },

      agreementDialog: {valid: false, content: ''},
      agreementDialogTitle: "隐私协议",

    }
  }, // end data
  mounted() {
    getEmployeeConfigSetting().then(({data}) => {
      console.log("LocalRegister getEmployeeConfigSetting", data)
      if (data.code === 200 && Array.isArray(data.data)) {
        data.data.forEach(item => {
          if (item.type === "UNIVERSAL" && item.content) {
            try {
              const c = JSON.parse(item.content)
              if (c) {
                if (c.searchEmployeeBy) this.employeeSetting.searchEmployeeBy = c.searchEmployeeBy
                if (c.nameSearch) this.employeeSetting.nameSearch = c.nameSearch
              }
            } catch (e) {
              console.error("LocalRegister parse UNIVERSAL content err", e)
            }
          }
        })
      }
    }).catch(err => {
      console.error("LocalRegister getEmployeeConfigSetting err", err)
    })
  },
  methods: {

    showAgreement() {
      this.agreementDialog = this.agreement
      this.agreementDialogTitle = "访客须知"
      this.agreementDialogVisible = true
    },
    showUserAgreement() {
      this.agreementDialog = this.userAgreement
      this.agreementDialogTitle = "用户协议"
      this.agreementDialogVisible = true
    },
    showPravicyAgreement() {
      this.agreementDialog = this.privacyAgreement
      this.agreementDialogTitle = "隐私协议"
      this.agreementDialogVisible = true
    },
    onDialogEnsure() {
      this.agreementDialogVisible = false
      this.haveRead = true
    },
    onSearch() {
      this.searchResult = []
      let inputText = (this.employee || "").trim()
      if (!inputText) {
        this.$message({
          message: this.emailOnly ? '请输入被访员工邮箱' : '请输入被访员工姓名/手机号',
          type: 'warning'
        });
        return
      }
      // 与后台 员工信息 配置对齐：仅邮箱模式按邮箱精确查；默认模式按手机号精确查、
      // 姓名按 完整查询(name)/模糊查询(matchName)
      let searchData = {}
      if (this.emailOnly) {
        searchData.email = inputText
      } else if (!isNaN(inputText)) {
        searchData.tel = inputText
      } else if (this.employeeSetting.nameSearch === "searchTypePart") {
        searchData.matchName = inputText
      } else {
        searchData.name = inputText
      }
      console.log("searchEmployee params", searchData)

      searchEmployee(searchData).then(({data}) => {
        console.log("searchEmployee result", data)
        if (data.code === 200) {
          if (data.data.length === 0) {
            this.$message.warning('未找到员工');
          } else {
            data.data.forEach(item => {
              this.searchResult.push(item)
            })
          }
        } else {
          this.showServerErrMsg(data.code)
        }
      }).catch(err => {
        console.log(err)
        this.showNetErrMsg()
      })

    },
    onEnsureClick(employee) {
      if (!this.haveRead && (this.userAgreement.valid || this.privacyAgreement.valid)) {
        this.$message({
          message: '请阅读并同意《隐私协议》',
          type: 'warning'
        });
        return
      }

      console.log(employee)

      this.$router.push({name: this.myPath.registerSelect, params: {employee: employee}})
    }
  }, // end methods
}
</script>
